/** Teams UI labels */
/*developer: Nithin
    date : 2024-06-19
    changes : Replaced Telecaller With Staff */

export const ROLE_LABELS = {
  accountant: 'Accountant',
  store_incharge: 'Store Incharge',
  store_staff: 'Store Staff',
  admin: 'Admin',
};

export const formatTeamRoleLabel = (role) => ROLE_LABELS[role] || role?.replace(/_/g, ' ') || '—';

export const getRoleBadgeStyle = (role) => {
  const normalized = String(role || '').toLowerCase();
  switch (normalized) {
    case 'admin':
    case 'owner':
      return 'bg-rose-50 text-rose-700 border-rose-200/50';
    case 'accountant':
      return 'bg-gray-50 text-gray-700 border-gray-200/50';
    case 'store_staff':
      return 'bg-cyan-50 text-cyan-700 border-cyan-200/50';
    case 'store_incharge':
      return 'bg-cyan-50 text-cyan-700 border-cyan-200/50';
    default:
      return 'bg-slate-50 text-slate-600 border-slate-200/50';
  }
};
